import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Api } from './api'
import { State } from './state'

/**
 * Core actions for cluster assignment.
 */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    assign: store.actions.request({
      input: store.actions.Data.asIs<Api.AssignInput>(),
      output: store.actions.Data.NONE,
    }),
    cancel: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: ({ state }) => State.cancelAssignment(state),
    }),
    initiate: store.actions.request({
      input: ({
        recordIds,
      }: {
        readonly recordIds?: readonly ents.extra.space.Record.Id[]
      } = {}) => ({ recordIds }),
      output: store.actions.Data.NONE,
      reducers: {
        success: ({ state }) => State.startAssignment(state),
      },
    }),
    submit: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
      reducers: {
        cancellation: ({ state }) => State.cancelSubmitting(state),
        error: ({ state, data: { error } }) =>
          State.failSubmitting(state, error),
        request: ({ state }) => State.startSubmitting(state),
        success: ({ state }) => State.cancelAssignment(state),
      },
    }),
    unassign: store.actions.request({
      input: store.actions.Data.asIs<Api.UnassignInput>(),
      output: store.actions.Data.NONE,
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
